/* geomap tracker ocnstants */
export const PAGE_VISIT_GEOMAPPING = 'PAGE_VISIT_GEOMAPPING';
export const ADD_GEOMAPPING_TARGET = 'ADD_GEOMAPPING_TARGET';
export const ADD_GEOMAPPING_BASE = 'ADD_GEOMAPPING_BASE';
export const EXPORT_FROM_GEOMAPPING = 'EXPORT_FROM_GEOMAPPING';

/* Crosstab tracker constants */
export const CROSSTAB_FULL_SHORT_LABEL_TOOGLE_MODE =
  'CROSSTAB_FULL_SHORT_LABEL_TOOGLE_MODE';
export const CROSSTAB_EDIT_EXPRESSION = 'CROSSTAB_EDIT_EXPRESSION';
export const CROSSTAB_CLEAR_SINGLE_ITEM = 'CROSSTAB_CLEAR_SINGLE_ITEM';
export const CROSSTAB_CLEAR_ALL_ITEMS = 'CROSSTAB_CLEAR_ALL_ITEMS';
export const CROSSTAB_SORT = 'CROSSTAB_SORT';
export const CROSSTAB_ITEM_RESTORE = 'CROSSTAB_ITEM_RESTORE';
export const CROSSTAB_CELL_HIGHLIGHT_FILTERING_OPEN =
  'CROSSTAB_CELL_HIGHLIGHT_FILTERING_OPEN';
export const CROSSTAB_CELL_HIGHLIGHT_FILTERING_APPLY =
  'CROSSTAB_CELL_HIGHLIGHT_FILTERING_APPLY';

/* composer constant */
export const COMPOSER_SEARCH_RESULT_SUCCESS = 'COMPOSER_SEARCH_RESULT_SUCCESS';
export const COMPOSER_SEARCH_RESULT_NOTFOUND =
  'COMPOSER_SEARCH_RESULT_NOTFOUND';
export const COMPOSER_EDIT_DEFINITION = 'COMPOSER_EDIT_DEFINITION';
export const COMPOSER_SUBMODULE = 'composer';
export const CO1_DEF_TAB = 'co1-def_tab';
export const CO1_DEF_SAVE = 'co1-def_save'
export const CO1_DEF_EDIT = 'co1-def_edit';
export const CO1_DEF_DELETE = 'co1-def_delete';
export const CO1_RUN_REPORT = 'co1-run_report';
export const CO1_SEARCH = 'co1-search';
// tracking events for Correspondence and Cluster
export const CAC_CHANGE_NODE_MAP_COLOR = 'CAC_CHANGE_NODE_MAP_COLOR';
/* CLUSTER AND CORRESPONDENCE TRACKING CONSTANTS */
export const CAC_EXPORT = 'CAC_EXPORT';
// tracker const for crosstab to composer and vice versa
export const CT1_CO1 = 'ct1-co1';
export const CO1_CT1 = 'co1-ct1';
// tracker const from essentials nav
export const NAVIGATION_MODULE = 'Navigation';
export const NAV_CT1 = 'nav-ct1';
export const NAV_CO1 = 'nav-co1';
export const NAV_CT2 = 'nav-ct2';


